import { AppTeamUtil } from '../../core/app-team-util';
import { Child } from '../children/child.model';
import { MyCampApp } from '../common/enumerations';

import CheckInCheckOutActivityType = MyCampApp.CheckInCheckOutActivityType;
import CheckInCheckOutValidationTypes = MyCampApp.CheckInCheckOutValidationTypes;
import { OrganizationAdmin } from '../organization/organization-admin.model';
import { OrganizationAdminReportModel } from '../organization/organization-admin-report.model';
import { Member } from '../member/member.model';

export class CheckInCheckOutActivityReportModel
{
	Activity!: CheckInCheckOutActivityType;
	ChildId!: number;
	GuardianMemberId?: number;
	Notes?: string;
	Date!: Date;
	Id = 0;
	LoggerUserId?: string;
	ScheduledDate?: Date; // For CheckOutScheduled activity only
	ValidationType?: CheckInCheckOutValidationTypes; // For CheckOutReleasedToGuardian activity only

	constructor(json?: any)
	{
		if (json)
		{
			// Map the json object to 'this' objects properties.
			Object.assign(this, json);

			this.Date = AppTeamUtil.convertApiDateStringToDate(json.Date)!;
			this.ScheduledDate = AppTeamUtil.convertApiDateStringToDate(json.ScheduledDate)!;
		}
	}

	get ActivityString(): string { return MyCampApp.activityTypeString(this.Activity); }
	get ValidationTyp3String(): string { return MyCampApp.validationTypeString(this.ValidationType); }
}

export class CheckInCheckOutReportData
{
	Children!: Child[];
	CheckInActivities!: CheckInCheckOutActivityReportModel[];
	CheckOutActivities!: CheckInCheckOutActivityReportModel[];
	Staff!: OrganizationAdminReportModel[];
	Members!: Member[];

	constructor(json?: any)
	{
		this.Children = json.Children.map((itemJson: any) => new Child(itemJson));
		this.CheckInActivities = json.CheckInActivities.map((itemJson: any) => new CheckInCheckOutActivityReportModel(itemJson));
		this.CheckOutActivities = json.CheckOutActivities.map((itemJson: any) => new CheckInCheckOutActivityReportModel(itemJson));
		this.Staff = json.Staff.map((itemJson: any) => new OrganizationAdmin(itemJson));
		this.Members = json.Members.map((itemJson: any) => new Member(itemJson));
	}
}
